import React from 'react';
import clsx from 'clsx';

export interface LoadingSkeletonProps {
    variant?: 'text' | 'circular' | 'rectangular';
    width?: string | number;
    height?: string | number;
    count?: number;
    className?: string;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ variant = 'text', width, height, count = 1, className }) => {
    const base = clsx('animate-pulse bg-surface-sunken', variant === 'circular' ? 'rounded-full' : variant === 'text' ? 'h-4 rounded-sm' : 'rounded-md');
    const style: React.CSSProperties = {
        width: width || (variant === 'circular' ? height : '100%'),
        height: height || (variant === 'text' ? '1rem' : undefined),
    };
    if (count > 1) {
        return (
            <div className="space-y-2">
                {Array.from({ length: count }).map((_, i) => <div key={i} className={clsx(base, className)} style={style} />)}
            </div>
        );
    }
    return <div className={clsx(base, className)} style={style} />;
};
export default LoadingSkeleton;
